import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { CounterInputV2 } from "../../../FormControlsV2";
import { MessageBalloon } from "../../../MessageBalloon/Index";
import { ReactComponent as PointIcon } from "../../../../assets/svg/icons/point.svg";
import { ReactComponent as AreaIcon } from "../../../../assets/svg/icons/areaIcon.svg";
import { ReactComponent as AnimalsIcon } from "../../../../assets/svg/icons/animais.svg";
import { ReactComponent as GrassIcon } from "../../../../assets/svg/icons/grass.svg";
import { ButtonPressed } from "../../../Buttons/ButtonPressed";
import { ButtonYesOrNo } from "../../../Buttons/ButtonYesOrNo";
import { format } from "date-fns";
import { parseUtcDate } from "../../../../utils/date/formatedDate";

interface InfoBrushCuttingProps {
  task: ITaskBrushCutting | undefined;
}

export default function InfoBrushCutting(task: InfoBrushCuttingProps) {
  const [taskBrushCutting, setTaskBrushCutting] = useState<ITaskBrushCutting>();
  const hasSkipReason = taskBrushCutting?.skip_reason != null;

  useEffect(() => {
    setTaskBrushCutting(task.task);
  }, []);

  return (
    <>
      <div>
        <span><Trans i18nKey="taskDetails.onPaddock" /></span>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <GrassIcon width={30} className="iconInitialTaskInfo" />
          <div className="labelInitialTaskInfo">
            <span>{taskBrushCutting?.initials}</span>
            <PointIcon width={15} />
          </div>
        </div>
      </div>

      <div className="containerQuestion">
        <MessageBalloon text={`A tarefa foi iniciada?`} pointed />
        <ButtonYesOrNo
          onlyResult
          optionSelected={hasSkipReason ? "no" : "yes"}
        />
      </div>

      {hasSkipReason ? (
        <MessageBalloon text={`${taskBrushCutting?.skip_reason}`} answer />
      ) : (
        <>
          <MessageBalloon
            text={`${format(parseUtcDate(taskBrushCutting?.start_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro inicial`} />
          <CounterInputV2
            name="info-brush-initial-h"
            suffix="h"
            value={Number(taskBrushCutting?.initial_hour_meter ?? 0)}
            disabled
          />

          <ButtonPressed
            onlyResult
            optionSelected={1}
            value={1}
            text={`Horímetro final`}
          />

          <MessageBalloon
            text={`${format(parseUtcDate(taskBrushCutting?.end_time) || 0, "dd/MM/yyyy - HH:mm")}`}
          />

          <MessageBalloon text={`Informar horímetro final`} />
          <CounterInputV2
            name="info-brush-final-h"
            suffix="h"
            value={Number(taskBrushCutting?.final_hour_meter ?? 0)}
            disabled
          />
        </>
      )}
    </>
  );
}
